/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerneedscontent2Inputs */

const en_flyerneedscontent2 = /** @type {(inputs: Flyerneedscontent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick an image or enter a title or a description.`)
};

const de_flyerneedscontent2 = /** @type {(inputs: Flyerneedscontent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle ein Bild oder gib einen Titel oder eine Beschreibung ein.`)
};

/**
* | output |
* | --- |
* | "Pick an image or enter a title or a description." |
*
* @param {Flyerneedscontent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerneedscontent2 = /** @type {((inputs?: Flyerneedscontent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerneedscontent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerneedscontent2(inputs)
	return de_flyerneedscontent2(inputs)
});
export { flyerneedscontent2 as "flyerNeedsContent" }